<template>
  <div class="GraphContainer">
    <!-- <DxButtonGroup
    style="float:left;padding-bottom:10px;padding-top:5px;"
    :items="filterBtns"
    styling-mode="outlined"
    key-expr="text"
    :size="{height:350}"
  ></DxButtonGroup> -->
    <div class="ChartHeader">{{ chartType }}</div>
    <div v-if="chartData.length > 0">
      <DxChart
        :ref="refName"
        :data-source="chartData"
        :bar-group-width="40"
        :redrawOnResize="true"
        :size="{ height: 250 }"
        :customizePoint="CustomBarChart"
      >
        <DxCommonSeriesSettings
          :ignore-empty-points="true"
          argument-field="channels"
          value-field="number"
          type="bar"
          :minBarSize="3"
          hoverMode="none"
        >
          <DxLabel
            :visible="true"
            :customize-text="customizeText"
            backgroundColor="transparent"
          >
          </DxLabel>
        </DxCommonSeriesSettings>
        <DxValueAxis :visual-range="chart_visualRange">
          <DxLabel :customize-text="customizeNumber" alignment="center">
            <DxFormat type="fixedPoint" :precision="0"></DxFormat>
          </DxLabel>
        </DxValueAxis>
        <DxSeriesTemplate name-field="channels" />
        <DxLegend
          vertical-alignment="top"
          horizontal-alignment="right"
          orientation="vertical"
          :visible="false"
        />
      </DxChart>
    </div>
  </div>
</template>

<script>
import {
  DxChart,
  DxSeriesTemplate,
  DxCommonSeriesSettings,
  DxLegend,
  DxLabel,
  DxValueAxis,
  DxFormat,
} from "devextreme-vue/chart";
import { DxButtonGroup } from "devextreme-vue/button-group";
import { EventBus } from "../../../components/Events";
export default {
  name: "ChannelUptimeChart",
  components: {
    DxChart,
    DxSeriesTemplate,
    DxCommonSeriesSettings,
    DxLegend,
    DxLabel,
    DxButtonGroup,
    DxValueAxis,
    DxFormat,
  },
  data() {
    return {
      loaderVisible: false,
      // filterBtns: [
      //     { text: "Month-to-Date", hint: "Month-to-Date" },
      //     { text: "Quarter-to-Date", hint: "Quarter-to-Date" },
      //   ],
      refName: "channelUptimeRef",
      rangeBuffer: 0,
      user: this.$auth.user.UserDetails,
      chart_visualRange: [0, 35],
      chartData: [],
    };
  },
  props: {
    isCcr: Boolean,
    dmaID: Number,
    chartType: String,
  },
  computed: {},
  mounted: function () {
    this.barChartCountsData();
    EventBus.$on("resize-chart", () => {
      this.resizeChart();
    });
  },
  methods: {
    resizeChart() {
      setTimeout(() => {
        this.$refs[this.refName]?.instance.render();
      }, 500);
    },
    customizeNumber({ valueText }) {
      var ranges = [
        { divider: 1e18, suffix: "E" },
        { divider: 1e15, suffix: "P" },
        { divider: 1e12, suffix: "T" },
        { divider: 1e9, suffix: "G" },
        { divider: 1e6, suffix: "M" },
        { divider: 1e3, suffix: "K" },
      ];
      valueText = valueText.replace(",", "");
      for (var i = 0; i < ranges.length; i++) {
        if (valueText >= ranges[i].divider) {
          let number = valueText / ranges[i].divider;
          var fixed = number.toFixed(1).toString();
          return fixed + ranges[i].suffix;
        }
      }
      return `<div>${valueText.toString()}</div>`;
    },
    CustomBarChart(info) {
      return { color: info.data.colour };
    },
    customizeText({ valueText }) {
      if (valueText == 0) {
        return ``;
      } else {
        return `<div style="color:grey;font-weight:bold;">${valueText}</div>`;
      }
    },
    barChartCountsData() {
      this.loaderVisible = true;
      let th = this;
      let filter = "";
      if (this.dmaID != undefined && this.dmaID != null) {
        if (this.isCcr) {
          filter =
            "?$filter=(MarketID eq " +
            this.dmaID +
            ") and ( DateRangeCategory eq '" +
            this.chartType +
            "')";
        } else {
          filter =
            "?$filter=(DMA_RecID eq " +
            this.dmaID +
            ") and ( DateRangeCategory eq '" +
            this.chartType +
            "')";
        }
      } else {
        filter = "?$filter=( DateRangeCategory eq '" + this.chartType + "')";
      }
      let url =
        "https://api.ccr.net/ColoM360/DMA_Dashboard_ChannelUptime_view" +
        filter;

      if (this.isCcr) {
        url =
          "https://api.ccr.net/ColoM360/M360Global_DMA_Dashboard_ChannelUptime_view" +
          filter;
      }
      this.$axios.get(url).then((response) => {
        th.chartData = [];
        let channelUptimeChartData = response.data.value;
        channelUptimeChartData = channelUptimeChartData.sort((a, b) => {
          return a.SortOrder > b.SortOrder ? 1 : -1;
        });
        if (this.dmaID != undefined && this.dmaID != null) {
          channelUptimeChartData.forEach((element) => {
            let obj = {
              channels: `${element.UptimeCategory}`,
              number: element.ChannelsByCategory,
              colour: `${element.CategoryColor}`,
            };
            th.chartData.push(obj);
          });
          th.rangeBuffer = parseInt(
            _.maxBy(th.chartData, "number")?.number * (5 / 100)
          );
          if (th.rangeBuffer <= 1) {
            th.rangeBuffer = 5;
          }
          th.chart_visualRange = [
            0,
            _.maxBy(th.chartData, "number")?.number + th.rangeBuffer,
          ];
        } else {
          var group = _.groupBy(channelUptimeChartData, "UptimeCategory");
          var result = _.map(_.keys(group), function (e) {
            return _.reduce(
              group[e],
              function (r, o) {
                r.colour = o.CategoryColor;
                return (r.number += +o.ChannelsByCategory), r;
              },
              { channels: e, number: 0, colour: 0 }
            );
          });
          th.chartData = result;
          th.rangeBuffer = parseInt(
            _.maxBy(th.chartData, "number")?.number * (10 / 100)
          );
          if (th.rangeBuffer <= 1) {
            th.rangeBuffer = 5;
          }
          th.chart_visualRange = [
            0,
            _.maxBy(th.chartData, "number")?.number + th.rangeBuffer,
          ];
        }
        this.loaderVisible = false;
        this.resizeChart();
        this.$emit("chart-data", this.chartData);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.GraphContainer::v-deep {
  text-align: center;
  .dxc-series {
    g {
      rect {
        rx: 4;
        ry: 4;
        // cursor: pointer;
      }
    }
  }
  .dxc-val-line,
  .dxc-arg-line {
    display: none;
  }
  .dxc-labels-group {
    .dxc-labels {
      g {
        rect {
          fill: none;
        }
        text {
          fill: black !important;
          font-size: 16px !important;
          font-weight: normal !important;
        }
      }
    }
  }
}
.ChartHeader {
  float: left;
  font-size: 16px;
  font-weight: bold;
  color: grey;
  padding-bottom: 10px;
}
</style>